// eslint-disable-next-line no-shadow
export var DEVICE_TYPES_ENUM;
(function (DEVICE_TYPES_ENUM) {
    DEVICE_TYPES_ENUM["AWW0SCLEVHN20"] = "RetailWebPlayer.web";
    DEVICE_TYPES_ENUM["A2IYUBDFJ0JQHI"] = "RetailWebPlayer.mobile";
    DEVICE_TYPES_ENUM["A3GUQNOIIEF57X"] = "RetailWebPlayer.mshop";
    DEVICE_TYPES_ENUM["A34OIAVFALWTNH"] = "MobileWebPlayer";
    DEVICE_TYPES_ENUM["A16ZV8BU3SN1N3"] = "WebPlayer";
})(DEVICE_TYPES_ENUM || (DEVICE_TYPES_ENUM = {}));
// eslint-disable-next-line no-shadow
export var DEVICE_TYPES_ENUM_FEEDBACK_DIALOG;
(function (DEVICE_TYPES_ENUM_FEEDBACK_DIALOG) {
    DEVICE_TYPES_ENUM_FEEDBACK_DIALOG["AWW0SCLEVHN20"] = "RetailWebPlayer.web";
    DEVICE_TYPES_ENUM_FEEDBACK_DIALOG["A2IYUBDFJ0JQHI"] = "RetailWebPlayer.mobile";
    DEVICE_TYPES_ENUM_FEEDBACK_DIALOG["A3GUQNOIIEF57X"] = "RetailWebPlayer.mshop";
    DEVICE_TYPES_ENUM_FEEDBACK_DIALOG["A34OIAVFALWTNH"] = "SKYFIRE-MOBILE-WEB";
    DEVICE_TYPES_ENUM_FEEDBACK_DIALOG["A16ZV8BU3SN1N3"] = "SKYFIRE";
})(DEVICE_TYPES_ENUM_FEEDBACK_DIALOG || (DEVICE_TYPES_ENUM_FEEDBACK_DIALOG = {}));
export const MOBILE_DEVICES = ['A34OIAVFALWTNH', 'A2IYUBDFJ0JQHI', 'A3GUQNOIIEF57X'];
export const UPSELL_ON_PLAYBACK_ERROR_DEVICES = ['A3GUQNOIIEF57X'];
export const MSHOP = ['A3GUQNOIIEF57X'];
export const RWP_BROWSER_DEVICE_TYPES = ['AWW0SCLEVHN20', 'A2IYUBDFJ0JQHI'];
export const RWP_DESKTOP_BROWSER_DEVICE_TYPE = 'AWW0SCLEVHN20';
export const RWP_DEVICE_TYPES = ['AWW0SCLEVHN20', 'A2IYUBDFJ0JQHI', 'A3GUQNOIIEF57X'];
